export default __webpack_public_path__ + "static/media/Justyna Ferensowicz.e8f1e928.webp";